import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';
import useFetch from '../useFetch';
import { useNavigate } from 'react-router-dom';
import { checkRoles } from '../../Utils/helper';
//import handleBackendResponse from '../../Utils/handleNotifications/handleBackendResponse';

export default function useHandleAllUsers() {
    const navigate = useNavigate()
        , fetch = useFetch(navigate);
        
    const { data: allUsersData, error, mutate } = useSWR(checkRoles(2) ? apiBaseURL + '/api/users' : null, {
        onSuccess: (data) => console.log('users hours fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    const isLoading = !allUsersData && !error;
    function getUsersWorkCenterById(userId) {
        const selectedUser = allUsersData?.find(user => user.id === userId);
        return selectedUser?.assignedLocation?.id;
    }

    return {
        error,
        mutate,
        isLoading,
        getUsersWorkCenterById,
    }
}